module.exports = __webpack_public_path__ + "static/img/wyfwright.af5457b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfwright.png
// module id = 5MNA
// module chunks = 1